/**
 * StreamingFilePicker Styled Components
 *
 * These extend/complement the base styles from input.styled.jsx
 * to add streaming-specific UI elements (progress, status icons, etc.)
 */

import styled from 'styled-components';
import { COLORS } from '../../constants/style/color';
import { rem } from '../../utils/style';

/**
 * Wrapper for progress indicator in file preview
 * Contains circular progress bar with percentage text overlay
 */
export const ProgressWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;

  .progress-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: ${rem(10)};
    font-weight: 600;
    color: ${COLORS.Iris};
    line-height: 1;
  }
`;

/**
 * Status indicator styles for upload states
 */
export const StatusIcon = styled.span`
  font-size: 24px;
  line-height: 24px;

  &.success {
    color: ${COLORS.Green};
  }
  &.failed {
    color: ${COLORS.Red};
  }
  &.uploading {
    color: ${COLORS.Iris};
  }
`;

/**
 * Action buttons container (retry, delete)
 */
export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
`;

/**
 * Individual action button
 */
export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${rem(4)};
  display: flex;
  align-items: center;
  justify-content: center;

  .material-symbols-outlined {
    font-size: ${rem(18)};
    color: ${COLORS.Gray};

    &:hover {
      color: ${COLORS.Red};
    }
  }

  &.retry-btn .material-symbols-outlined:hover {
    color: ${COLORS.Iris};
  }
`;

/**
 * Error message display
 */
export const ErrorMessage = styled.div`
  color: ${COLORS.Red};
  font-size: ${rem(12)};
  margin-top: ${rem(4)};
`;
